var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 13.3332V19.9998C29.3333 26.6665 26.6667 29.3332 20 29.3332H12C5.33332 29.3332 2.66666 26.6665 2.66666 19.9998V11.9998C2.66666 5.33317 5.33332 2.6665 12 2.6665H18.6667",
    fill: "#B6C0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 13.3332V19.9998C29.3333 26.6665 26.6667 29.3332 20 29.3332H12C5.33332 29.3332 2.66666 26.6665 2.66666 19.9998V11.9998C2.66666 5.33317 5.33332 2.6665 12 2.6665H18.6667",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 13.3332H24C20 13.3332 18.6667 11.9998 18.6667 7.99984V2.6665L29.3333 13.3332Z",
    fill: "#B6C0F3",
    stroke: "#4A56DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.2ec72f7416329d924c7074d445f68f7c.svg";
export { ForwardRef as ReactComponent };